export const getDigitalVaultURLs = (entityType: 'site' | 'document' | 'device', uuid?: string) => {
  const path = `/${entityType}/${uuid}`
  const edit = `/me${path}`
  const shared = `/me/shared${path}`
  return {
    edit,
    shared,
  }
}
